/**
 * API Base URL Configuration
 *
 * Uses environment variable with fallbacks:
 * 1. REACT_APP_API_URL (user-specified)
 * 2. Production fly.io URL
 * 3. Local development URL
 */

/**
 * Get API base URL
 * @returns {string} API base URL
 */
export const getApiBaseUrl = () => {
  // Check for environment variable (set in Vercel or .env.local)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Default to fly.io backend for production
  if (process.env.NODE_ENV === 'production') {
    return 'https://flokraft-backend.fly.dev';
  }

  // Local development
  return 'https://flokraft-backend.fly.dev';
  //return 'http://localhost:8080';
};

export const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;
